import React from "react"
import {createRoot} from "react-dom/client"
import {Typography} from "antd"
import App from "./App"
import "./assets/global.css"

declare global {
    interface Window {
        lascholar: any
        lavirtuallab: any
        userprofile: any
    }
}

fetch(`${window.location.origin}/config.json`).then(data => data.json()).then(data => {
    window.lascholar = data.lascholar;
    window.lavirtuallab = data.lavirtuallab;
    window.userprofile = data.userprofile;
    createRoot(document.getElementById("root") as HTMLElement).render(
        <React.StrictMode>
            <React.Suspense fallback={
                <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <Typography.Text>Chargement des données...</Typography.Text>
                </div>
            }>
                <App/>
            </React.Suspense>
        </React.StrictMode>
    );
})
